<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:51:01
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-popover placement="bottom" width="200" trigger="hover" @show="show" :disabled="promotion.isDisabled" :content="content">
			<rd-status :statusType="promotion.type" slot="reference" :class="[promotion.isDisabled ? '' : 'cursor-pointer']">
				{{ promotion.label }}
				<i class="el-icon-arrow-right mt-2" v-if="!promotion.isDisabled"></i>
			</rd-status>
		</el-popover>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { productCommonLog } from '@/api/secondColonelManage';
export default {
	mixins: [mixin],
	computed: {
		promotion({ row }) {
			let status = row.promotionStatus || '1';
			let obj = {
				1: {
					label: '推广中',
					type: 'success',
					isDisabled: true,
				},
				2: {
					label: '中止推广',
					type: 'error',
					isDisabled: false,
				},
				3: {
					label: '已失效',
					type: 'primary',
					isDisabled: true,
				},
			};
			return obj[status];
		},
	},
	data() {
		return {
			content: '',
		};
	},
	methods: {
		async show() {
			const { list = [] } = await productCommonLog({ id: this.row.productCommonId, type: '2' });
			this.content = list[0]?.remark || '';
		},
	},
};
</script>
<style lang="less" scoped>
</style>